/**
 * Centralized logging: debug/info/warn only in development; errors always surface (production-safe ops/debugging).
 */

const isDev =
  typeof import.meta !== 'undefined' &&
  Boolean(import.meta.env?.DEV)

function formatParts(message: unknown, optionalParams: unknown[]): unknown[] {
  return optionalParams.length ? [message, ...optionalParams] : [message]
}

export const logger = {
  debug(message?: unknown, ...optionalParams: unknown[]): void {
    if (!isDev) return
    console.debug(...formatParts(message, optionalParams))
  },

  info(message?: unknown, ...optionalParams: unknown[]): void {
    if (!isDev) return
    console.info(...formatParts(message, optionalParams))
  },

  warn(message?: unknown, ...optionalParams: unknown[]): void {
    if (!isDev) return
    console.warn(...formatParts(message, optionalParams))
  },

  error(message?: unknown, ...optionalParams: unknown[]): void {
    console.error(...formatParts(message, optionalParams))
  },
}
